/*
 * @Author: 朱元培 zhuyp41266@hundsun.com
 * @Date: 2023-06-19 10:21:52
 * @LastEditors: 朱元培 zhuyp41266@hundsun.com
 * @LastEditTime: 2023-08-04 17:38:56
 * @FilePath: \deal\src\store\getters.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
const getters = {
  // user.js 模块下的getters
  userInfo: state => state.user.userInfo, // 当前登录用户信息
  // main.js 模块下的getters
  isLogin: state => state.main.isLogin, // 是否登录
  activeName: state => state.main.activeName,
  routeParams: state => state.main.routeParams, // 路由跳转参数
  producList: state => state.main.producList,
  // userInfo: state => state.main.userInfo, // 当前登录用户信息
  // 申购
  tradeResult: state => state.main.tradeResult, // 当前申购交易结果
  currStepId: state => state.main.currTradeResStepId, // 当前交易结果步骤
  fundDetailObj: state => state.main.fundDetailObj, // 基金详情
  // 赎回
  redeObj: state => state.main.redeObj, // 当前赎回基金详情
  fundRedeObj: state => state.main.fundRedeObj, // 当前赎回基金预览详情
  currRedeStepId: state => state.main.currRedeStepId, // 当前交易结果步骤
  // 转换
  currTransStepId: state => state.main.currTransStepId, // 当前交易结果步骤
  transObj: state => state.main.transObj, // 转换基金详情
  transFormObj: state => state.main.transFormObj, // 转换基金表单详情
  fixModifyRowObj: state => state.main.fixModifyRowObj, // 修改当前定投基金详情
  createAcconStep: state => state.main.createAcconStep, // 开户步骤
  createAccoInfo: state => state.main.createAccoInfo, // 开户信息
  openAccoProtocolList: state => state.main.openAccoProtocolList, // 开户协议信息
  fixFormObj: state => state.main.fixFormObj, // 当前定投基金表单详情
  modifyFixStepId: state => state.main.modifyFixStepId,
  fixResultObj: state => state.main.fixResultObj, // 当前定投结果
  newFixStepId: state => state.main.newFixStepId, // 创建定投步骤ID
  fixNewFormObj: state => state.main.fixNewFormObj, // 创建定投表单信息
  newFixResultObj: state => state.main.newFixResultObj, // 创建定投基金结果
  currFixFundObj: state => state.main.currFixFundObj, // 当前定投基金信息
  currNewFixStepId: state => state.main.currNewFixStepId, // 当前定投基金步骤ID
  currFixResultObj: state => state.main.currFixResultObj, // 当前定投基金结果
  newFixFund: state => state.main.newFixFund, // 创建定投 - 选择基金代码
  // 超级现金宝-立即充值
  superXjbCurrStepId: state => state.main.superXjbCurrStepId, // 当前交易结果步骤
  superXjbDetailObj: state => state.main.superXjbDetailObj, // 交易详情
  superXjbTradeResult: state => state.main.superXjbTradeResult, // 当前交易结果
  // 超级现金宝-定期充值
  superXjbFixStepId: state => state.main.superXjbFixStepId, // 当前交易结果步骤
  superXjbFixDetailObj: state => state.main.superXjbFixDetailObj, // 交易详情
  // 超级现金宝-取现
  superXjbRedeemStepId: state => state.main.superXjbRedeemStepId, // 当前交易结果步骤
  superXjbRedeemDetailObj: state => state.main.superXjbRedeemDetailObj, // 交易详情
  // 组件配置
  components: state => state.component.components,
}

export default getters;